import { Box, Link } from '@mui/material';
import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import Utils from '../../../utils/Utils';
import BlockImageData from './BlockImageData';
import styles from './BlockImage.module.css';
import BlockProps from '../../../models/BlockProps';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import ImageSettingsModal from '../../Modals/ImageSettingsModal/ImageSettingsModal';
import BlockData from '../../../models/BlockData';
import CroppedImage from '../../CroppedImage';
import useGetBackground from '../../../hooks/UseGetBackground';
import BackGroundImageModal from '../../Modals/ImageModal/BackGroundImageModal';
import useParallaxScript from '../../../hooks/useParallaxScript';
import config from '../../../config';
import ImageEnlargeModal from '../../Images/ImageEnlargeModal';

export interface BlockImageProps extends BlockProps {
  blockData: BlockData[]
}

function BlockImage({
  data,
  isEditing,
  isTemplate,
  editHandler,
  showImageSettingsModal,
  onCloseImageSettingsModal,
  blockData,
  showImageModal,
  onCloseImageModal,
}: BlockImageProps) {
  const targetModalId = uuid();

  const [props, setProps] = useState<BlockImageData>(data.data as BlockImageData);

  useEffect(() => {
    setProps(data.data as BlockImageData);
  }, [data.data]);

  const elementUuid = uuid();
  useParallaxScript(props.backgroundImage?.settings?.parallaxBool, elementUuid, config.backgroundImage.parallaxEffect);

  return (
    <Box
      id={elementUuid}
      sx={{
        p: 1.5,
        overflow: 'hidden',
        ...useGetBackground(
          props.backgroundImage?.solidColor,
          props.backgroundImage?.value,
          props.backgroundImage?.settings?.scale,
          props.backgroundImage?.settings?.scaleBool,
        ),
        backgroundPosition: 'center 0px',
      }}
    >
      {(isEditing && !isTemplate) && (
        <BackGroundImageModal
          backgroundImage={props.backgroundImage}
          isShowModal={showImageModal}
          onCloseModal={onCloseImageModal}
          handleOnConfirm={(url: BlockComponentImage) => {
            const tempBg = { ...props, backgroundImage: { ...url } };
            setProps(tempBg);
            editHandler(data.id, tempBg);
          }}
        />
      )}
      <Box className="block-content-wrapper">
        <Box
          className={styles.imageBoxContainer}
          sx={Utils.hoverBorder(isEditing, {
            height: 'auto',
            position: 'static',
          })}
        >
          <ImageSettingsModal
            isEditing={isEditing}
            blockData={blockData}
            showModal={showImageSettingsModal}
            closeModal={onCloseImageSettingsModal}
            image={props.url}
            disabled={isTemplate || !isEditing}
            onConfirm={(newImage: BlockComponentImage) => {
              props.url = newImage;
              editHandler(data.id, props);
            }}
          >
            {(!isEditing) ? (
              <Link
                style={{ cursor: props?.url?.link?.linkData?.url ? 'pointer' : 'default' }}
                target={props?.url?.link?.linkData?.openType}
                href={props?.url?.link?.linkData?.url || undefined}
                sx={{
                  width: '100%',
                  height: '100%',
                }}
                rel="noreferrer"
              >
                <CroppedImage
                  image={props.url}
                  isEditing={isEditing}
                  settings={props.url.settings}
                  targetModalId={targetModalId}
                />
              </Link>
            ) : (
              <CroppedImage
                image={props.url}
                isEditing={isEditing}
                settings={props.url.settings}
                targetModalId={targetModalId}
              />
            )}
          </ImageSettingsModal>
        </Box>
      </Box>

      <ImageEnlargeModal
        images={[props.url]}
        targetModalId={targetModalId}
      />
    </Box>
  );
}

export default BlockImage;
